<template>
  <div class="card-wrapper">
    <div class="card-contents">
      <span v-if="contentType !== 'my' && !content.available" class="img">
        <img
          crossorigin="anonymous"
          alt="capture"
          :src="content.captureUrl"
          :class="{ 'loaded':  isLoaded }"
          @load="onLoaded"
          @error="onErrored"
          ref="capture"
        >
        <div class="unusable">
          <template v-for="planName in content.planNames">
           <span class="plan" :key="planName">
              {{ planName }}
            </span>
          </template>
        </div>
      </span>
      <span v-else class="img">
        <img
          crossorigin="anonymous"
          alt="capture"
          :src="content.captureUrl"
          :class="{ 'hover': isHovered, 'loaded':  isLoaded }"
          @load="onLoaded"
          @error="$emit('captureError', $event)"
          ref="capture"
        >
      </span>
      <div class="text-box" v-if="isShowInfo">
        <div v-if="contentType === 'my'" class="id">
          <div><span>ID</span>{{ content.code }}</div>
          <div v-if="kind === 'zip_export'" class="zip-export">
            {{ content.kind == 'rel_export' ? '相対パス' : '絶対パス' }}
         </div>
        </div>
        <div class="name-box">
          <div
            v-if="contentType === 'my' && content.showInput.name"
            key="name"
            class="main-input"
          >
            <input
              type="text"
              v-model="content.name"
              @keypress.enter="$event.target.blur"
              @blur="$emit('toggleSave', content, 'name', index)"
              :ref="'name' + index"
            />
          </div>
          <div
            v-else
            key="name"
          >
            <span>{{content.name}}</span>
          </div>
          <button
            class="pen"
            v-if="!isNew && contentType === 'my' && kind === 'origin' && !content.showInput.name"
            @click="$emit('toggleShowInput', content, 'name', index)"
          >
            <i class="fas fa-pen"></i>
          </button>
        </div>
        <div v-if="contentType === 'my'" class="update-info">
          <span class="info-key">更新者</span><span>：{{ content.savedUserName }}</span>
        </div>
        <div v-if="contentType === 'my'" class="update-info">
          <span class="info-key">更新日時</span><span>：{{ content.savedOn }}</span>
        </div>
        <div v-if="contentType === 'my'" class="update-info">
          <span class="info-key">サイズ</span><span>：{{ Math.ceil(content.size / 1024).toLocaleString() }}KB</span>
        </div>
        <template v-if="contentType === 'my' && content.kind === 'hosting'">
          <div class="update-info">
            <span>検索結果に表示</span><span>：{{ content.flgSearchIndex ? 'する' : 'しない' }}</span>
          </div>
        </template>
        <template v-if="!isNew && content.expireCountDown">
          <div class="expire-count-down">
            <span>{{ content.kind === 'rel_export' ? '保存期限' : '公開期限' }} {{ content.expireCountDown }}</span>
            <a v-if="kind === 'hosting'" :href="content.hostingUrl" target="_blank"><i class="fas fa-external-link-alt"></i></a>
          </div>
        </template>
        <ul class="tmpl-tag">
          <li v-for="(tag, index) in content.tags" :key="index">{{tag.name}}</li>
        </ul>
        <div
          v-if="contentType === 'my' || content.available"
          class="tmpl-nav"
          @mouseover="mouseOverAction"
          @mouseleave="mouseLemoveAction"
        >
          <div
            class="tile-checkbox"
            v-if="!isNew && contentType === 'my'"
            :class="{ 'hover': isHovered }"
            v-show="content.checked || isHovered"
          >
            <input
              type="checkbox"
              v-model="content.checked"
              :id="content.id"
            />
            <label :for="content.id"></label>
          </div>
          <ul class="menu" :class="{ 'hover': isHovered }">
            <template v-if="contentType === 'my'">
              <template v-if="isNew">
                <li class="preview"><a @click="$emit('htmlPreview', content)">プレビュー</a></li>
                <li class="copy"><a @click="$emit('copy', content)">コピーして作成</a></li>
              </template>
              <template v-else>
                <template v-if="kind === 'origin'">
                  <li class="preview"><a @click="$emit('htmlPreview', content)">プレビュー</a></li>
                  <li class="edit"><router-link :to="{name: 'contentEdit', params:{id: id}}">編集</router-link></li>
                  <li class="copy"><a @click="$emit('copy', content)">コピーして作成</a></li>
                  <li class="delete"><a @click="$emit('deleteConfirm', content)">削除</a></li>
                </template>
                <template v-if="kind === 'mp'">
                  <li class="preview"><a @click="$emit('htmlPreview', content)">プレビュー</a></li>
                  <li class="copy"><a @click="$emit('copy', content)">コピーして作成</a></li>
                  <li class="delete"><a @click="$emit('deleteConfirm', content)">削除</a></li>
                </template>
                <template v-if="kind === 'ec_v1'">
                  <li class="preview"><a @click="$emit('htmlPreview', content)">プレビュー</a></li>
                  <li class="copy"><a @click="$emit('copy', content)">コピーして作成</a></li>
                  <li class="delete"><a @click="$emit('deleteConfirm', content)">削除</a></li>
                </template>
                <template v-if="kind === 'ec_v2'">
                  <li class="preview"><a @click="$emit('htmlPreview', content)">プレビュー</a></li>
                  <li class="copy"><a @click="$emit('copy', content)">コピーして作成</a></li>
                  <li class="delete"><a @click="$emit('deleteConfirm', content)">削除</a></li>
                </template>
                <template v-if="kind === 'mp_lite'">
                  <li class="preview"><a @click="$emit('htmlPreview', content)">プレビュー</a></li>
                  <li class="copy"><a @click="$emit('copy', content)">コピーして作成</a></li>
                  <li class="delete"><a @click="$emit('deleteConfirm', content)">削除</a></li>
                </template>
                <template v-if="kind === 'mp_next'">
                  <li class="preview"><a @click="$emit('htmlPreview', content)">プレビュー</a></li>
                  <li class="copy"><a @click="$emit('copy', content)">コピーして作成</a></li>
                  <li class="delete"><a @click="$emit('deleteConfirm', content)">削除</a></li>
                </template>
                <template v-if="kind === 'hosting'">
                  <li class="preview"><a @click="$emit('htmlPreview', content)">プレビュー</a></li>
                  <li class="copy"><a @click="$emit('copy', content)">コピーして作成</a></li>
                  <li class="delete"><a @click="$emit('deleteConfirm', content)">削除</a></li>
                </template>
                <template v-if="kind === 'zip_export'">
                  <li class="preview"><a @click="$emit('htmlPreview', content)">プレビュー</a></li>
                  <li class="copy"><a @click="$emit('copy', content)">コピーして作成</a></li>
                  <li class="download"><a @click="$emit('download', content)">ダウンロード</a></li>
                  <li class="delete"><a @click="$emit('deleteConfirm', content)">削除</a></li>
                </template>
              </template>
            </template>
            <template v-else>
              <li class="preview"><a @click="$emit('htmlPreview', content)">プレビュー</a></li>
              <li class="new"><a @click="$emit('createContent', content)">新規作成</a></li>
            </template>
          </ul>
          <div v-if="isExtTypeNameEcV1 && content.ecContentId != null" class="tmpl-id" :class="{ 'hover': isHovered }">
            <p>
              <span>メールテンプレートID : </span>
              <span>{{ content.ecContentId }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'content',
    'id',
    'index',
    'contentType',
    'isNew',
    'kind',
    'isShowInfo',
    'extTypeName',
  ],
  data () {
    return {
      isHovered: false,
      isLoaded: false,
    }
  },
  computed: {
    isExtTypeNameEcV1 () {
      return this.extTypeName === 'ec_v1'
    },
  },
  methods: {
    mouseOverAction () {
      this.isHovered = true
    },
    mouseLemoveAction () {
      this.isHovered = false
    },
    onLoaded () {
      this.isLoaded = true
    },
    onErrored (event) {
      this.isLoaded = true
      this.$emit('captureError', event)
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  color: $commonFontColor;
}
.card-contents {
  width: 250px;
  padding: 8px;
  position: relative;
  &:hover{
    background: rgba(84, 150, 232, 0.1);
    border-radius: 2px;
  }
  // テンプレート画像
  .img {
    position: relative;
    border: .5px solid #e0e0e0;
    border-radius: 3px;
    overflow: hidden;
    display: flex;
    margin: 0 auto 8px;
    width: 230px;
    height: 230px;
    align-items: center;
    img {
      opacity: 0;
      vertical-align: middle;
      width: 230px;
      max-width: 100%;
      height: 230px;
      object-fit: cover;
      object-position: 50% top;
      transition: all 0.3s ease 0s;
      &.hover {
        filter: brightness(50%) blur(3px);
        transition: all 0.3s ease 0s;
      }
      &.loaded {
        opacity: 1;
      }
    }
    .unusable {
      width: 100%;
      text-align: center;
      position: absolute;
      display: flex;
      flex-direction: column;
      .plan {
        background-color: #FFB135;
        border-radius: 20px;
        color: #FFFFFF;
        padding: 10px 20px;
        margin-bottom: 10px;
      }
    }
  }
  // タイトル・日付・タグ
  .text-box {
    padding: 2px 10px 10px 10px;
    .pen {
      background: inherit;
      cursor: pointer;
      user-select: none;
      padding-left: 3px;
    }
    .name-box {
      display: flex;
      flex: 1;
      > div {
        overflow: hidden;
      }
      span {
        font-size: 16px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        display: block;
      }
      .main-input {
        margin-top: 0;
      }
      input {
        margin-bottom: 10px;
      }
    }
    .id {
      font-size: 12px;
      color: rgba(#484848, 0.6);
      margin-bottom: 5px;
      display: flex;
      justify-content: space-between;
      span {
        display: inline-block;
        text-align: center;
        border-radius: 12px;
        background: #e4e4e4;
        width: 30px;
        height: 19px;
        margin-right: 8px;
      }
      .zip-export {
        font-size: 14px;
        color: $commonFontColor;
        height: 20px;
        line-height: 20px;
        max-width: 190px;
        padding: 0 10px;
        background: #fff;
        border-radius: 12px;
      }
    }
    .update-info {
      .info-key {
        display: inline-block;
        width: 57px;
      }
    }
    .tmpl-tag {
      margin-top: 5px;
      overflow: hidden;
      width: 100%;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      li {
        height: 24px;
        line-height: 24px;
        max-width: 190px;
        display: inline-block;
        padding: 0 10px;
        margin: 0 5px 0 0;
        background: #fff;
        border-radius: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        transition: all 0.3s ease 0s;
        &:hover, &:active {
          background: #e4e4e4;
          transition: all 0.3s ease 0s;
        }
      }
    }
    .expire-count-down {
      font-size: 14px;
      margin-top: 5px;
      a {
        display: inline-block;
        padding-left: 10px;
      }
    }
    // 画像ホバー時のメニュー
    .tmpl-nav {
      position: absolute;
      width: 230px;
      height: 230px;
      top: 10px;
      left: 18px;
      &>ul {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.3s ease 0s;
        display: none;
        &.hover {
          display: block;
          transition: all 0.3s ease 0s;
        }
        li {
          white-space: nowrap;
          color:#fff;
          font-weight: 300;
          padding: 0 10px;
          border-radius: 2px;
          transition: all 0.3s ease 0s;
          cursor: pointer;
          a {
            color:#fff;
            display: block;
            margin: 15px auto;
            width: 100%;
            &:hover, &:active {
              color: #bbbbbb;
              transition: all 0.3s ease 0s;
            }
            &::before {
              font-family: "Font Awesome 5 Free";
              padding-right: 8px;
            }
          }
          &.edit a::before {
            content: '\f044';
            font-weight: 900;
          }
          &.preview a::before {
            content: '\f06e';
            padding-right: 7px;
          }
          &.copy a::before {
            content: '\f0c5';
            padding-right: 9px;
          }
          &.delete a::before {
            content: '\f2ed';
            padding-right: 10px;
          }
          &.download a::before {
            content: '\f019';
            font-weight: 900;
            padding-right: 9px;
          }
          &.new a::before {
            content: '\f067';
            font-weight: 900;
            padding-right: 10px;
          }
        }
      }
      // 一括操作のチェックボックス
      .tile-checkbox {
        position: absolute;
        top:10px;
        left: 10px;
        &.hover {
          display: block;
          transition: all 0.3s ease 0s;
        }
        input[type=checkbox] {
          display:  none;
          + label {
            font-size: 12px;
            margin-bottom: 0;
            display: inherit;
            line-height: 20px;
            &::before {
              width: 20px;
              height: 20px;
              vertical-align: bottom;
              margin-right: 8px;
              display: inline-block;
              content: '';
              border-radius: 4px;
              background: #cfcfcf;
            }
          }
          &:checked + label::before {
            font-size: 14px;
            box-sizing: border-box;
            font-family: "Font Awesome 5 Free";
            padding-left: 3px;
            content: '\f00c';
            display: inline-block;
            font-weight: 900;
          }
        }
      }
      .tmpl-id {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        color: #FFFFFF;
        font-size: 14px;
        padding: 5px;
        line-height: 1.2;
        box-sizing: border-box;
        background-color: rgba(0,0,0,0.2);
        transition: backdrop-filter 0.3s ease 0s;
        text-align: center;
        backdrop-filter: blur(3px);
        &.hover {
          backdrop-filter: blur(0px)
        }
      }
    }
  }
}
</style>
